import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Layout, Button, ConfigProvider, theme, FloatButton } from "antd";
import { CONSTANTS } from "../utils/constants";
import { clearTestStorage, redirectToPlural } from "../utils/common";

const { Header, Content, Footer } = Layout;

const MainLayout = () => {
  const navigate = useNavigate();
  const isHome = useLocation()?.pathname === '/';
  const token = sessionStorage.getItem('token');

  const handleBackToPlural = () => {
    clearTestStorage();
    setTimeout(() => {
      redirectToPlural();
    }, 200);
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            contentBg: 'rgb(255,249,219)',
            headerBg: 'rgb(255,249,219)',
            colorBorder: 'rgb(208,177,5)',
          },
        },
      }}
    >
      <Layout>
        <Header className="!bg-yellow-100 !px-0">
          <div className="flex justify-between items-center container mx-auto h-full px-3">
            <div className="flex flex-wrap">
              <h1 className="!m-0 !font-bold text-xs lg:text-xl">
                {CONSTANTS.BAB1}&nbsp;
              </h1>
              <h2 className="!m-0 !font-bold text-xs lg:text-xl">{CONSTANTS.BAB2}</h2>
            </div>
            {(token && !isHome) ?
              <Button type="link" onClick={() => navigate("/")} className="!px-0">
                {CONSTANTS.BACKTOQUIZZES}
              </Button> :
              <Button type="link" onClick={handleBackToPlural} className="!px-0">
                {CONSTANTS.BACKTOPLURAL}
              </Button>
            }
          </div>
        </Header>
        <Content className="min-h-[calc(100vh-133px)] container mx-auto">
          <FloatButton.BackTop />
          <Outlet />
        </Content>
        <Footer className="bg-yellow-100">
          <div className="container mx-auto flex flex-wrap justify-between items-center gap-3 text-center lg:text-left">
            <p>{CONSTANTS.FOOTERTEXTLEFT}</p>
            <p className="text-red-500">{CONSTANTS.FOOTERTEXTRIGHT}</p>
          </div>
        </Footer>
      </Layout>
    </ConfigProvider>
  );
};

export default MainLayout;